import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, input, model, OnInit, output, signal, TemplateRef, viewChild, ViewChild } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { IconsService } from 'src/app/shared/services/icons.service';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { SettlementsService } from 'src/app/services/settlements.service';
import { switchMap, tap } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-tank-approvals',
  standalone: true,
  imports: [
    FontAwesomeModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule
],
  templateUrl: './modal-tank-approvals.html',
  styleUrl: './modal-tank-approvals.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalTankApprovals implements OnInit {
  approvalType = input<string>('');
  reload = output<boolean>();
  toastService = inject(ToastrService);
  icons = inject(IconsService);
  modalService = inject(NgbModal);
  settlementService = inject(SettlementsService);
  fb = inject(FormBuilder);
  currentTemplate = signal<TemplateRef<unknown> | null>(null);
  private modalRef: NgbModalRef | undefined;
  auth = viewChild<TemplateRef<unknown>>('auth');
  @ViewChild('modalTankApprovals') modalTankApprovalsElem!: ElementRef;
  authTemplate = viewChild<TemplateRef<unknown>>('auth');
  otpCodeTemplate = viewChild<TemplateRef<unknown>>('otpCode');
  authForm!: FormGroup;
  private authData = signal<any>(null);
  otpData = model<any>();
  idTank = input<number | null>(null);

  constructor() {
    this.authForm = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.currentTemplate.set(this.authTemplate()!);
  }

  authentication() {
    let payload = {
      user: {
        email: this.authForm.value.email,
        password: this.authForm.value.password
      }
    };
    this.settlementService.login(payload).pipe(
      tap(res => {
        this.authData.set(res);
      }),
      switchMap(() => {
        switch(this.approvalType()) {
          case 'gas_meter':
            return this.settlementService.otpCodeGasMeter(this.authData().token, this.idTank()!);
          default:
            return this.settlementService.otpCodeApprovalTank(this.authData().token, this.idTank()!);
        }
      })
    ).subscribe({
      next: (res: any) => {
        this.toastService.success(res.message);
      }
    })
      
    this.currentTemplate.set(this.otpCodeTemplate()!);
  }

  openModal(modalContent: TemplateRef<any>) {
    this.modalRef = this.modalService.open(modalContent, {backdrop: 'static'});
    this.authData.set(null);
    this.otpData.set(null);
  }

  dismiss() {
    if (this.modalRef) {
      this.reload.emit(true);
      this.modalRef.dismiss();
      this.currentTemplate.set(this.auth()!);
      this.authForm.reset();
      this.authData.set(null);
      this.otpData.set(null);
    }
  }

  validateOtp() {
    this.settlementService.createApproval(this.authData().token, this.idTank()!, { otp: this.otpData()}, this.approvalType()).subscribe({
      next: () => {
        const message = this.approvalType() === 'gas_meter' ? 'Medidor aprobado' : 'Tanque Aprobado';
        this.toastService.success(message);
        this.dismiss();
      },
      error: () => {
        this.toastService.error('El OTP es inválido');
      }
    });
  }
}
